import React, { Fragment } from 'react';

import Footer from 'components/footer';

const PublicLayout = ({ children }) => (
  <Fragment>
    {children}
    <Footer />
  </Fragment>
);

export default PublicLayout;
